import React, {useContext} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    Flex,
    PriorityIcon,
    Separator
} from '@priority-software/priority-style-react';

import {AppSearchesContext} from '../AppSearchesContext';
import styles from './styles.module.scss';
import General from './General';

import Conditions from './Conditions';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {getFormtitle} from '../utils';

const AppSearchesDialog = () => {
    const {isOpen, handleClose} = useContext(AppSearchesContext);

    return (
        <Dialog
            componentClasses={styles.dialog}
            onClose={handleClose}
            isOpen={isOpen}
            closable
            content={<Content />}
            footer={<Footer />}
            title={
                <DialogTitle
                    textColor="primary-500"
                    skin="h3"
                    title={getLocalizedText(texts.AppSearchDlgTitle).replace('X', getFormtitle())}
                />
            }
        />
    );
};

const Content = () => {
    return (
        <Flex
            componentClasses={styles.dialogContent}
            justifyContent="flex-start"
            alignItems="flex-start"
        >
            <General />
            <Separator componentClasses={styles.separator} align="horizontal" />
            <Conditions />
        </Flex>
    );
};

const Footer = () => {
    const {handleSave, handleClose, handleClear, isDirty} = useContext(AppSearchesContext);

    return (
        <Flex componentClasses={styles.footer} justifyContent="space-between">
            <Button
                onClick={handleClear}
                skin="text"
                componentClasses="clear-search-button"
                prefixIcon={PriorityIcon.clear}
            >
                {getLocalizedText(texts.clearSearch)}
            </Button>
            <Flex componentClasses={styles.actionButtons} justifyContent="flex-end">
                <Button width="fullWidth" size="large" skin="secondary" onClick={handleClose}>
                    {getLocalizedText(texts.AppSearchCancel)}
                </Button>
                <Button disabled={!isDirty} width="fullWidth" size="large" onClick={handleSave}>
                    {getLocalizedText(texts.save)}
                </Button>
            </Flex>
        </Flex>
    );
};

export default AppSearchesDialog;
